<template>
  <li id="children-certificates">
    <span class="h3">Child {{ childIndex }} birth certificate details</span>
    <div class="status warn">
      These are the details that are on your child's birth certificate.
    </div>
    <ol class="questions">
      <li>
        <fieldset>
          <legend>
            <span class="label">Place of birth or adoption</span>
          </legend>
          <ol class="questions">
            <li>
              <InputWithError
                v-model="localForm[`birthTownCityChild${childIndex}`]"
                :id="`birthTownCityChild${childIndex}`"
                :name="`Child ${childIndex} Birth Town or City`"
                label="Town or city"
                maxlength="60"
                size="15"
                @input="onInputChange"
              />
            </li>
            <li>
              <InputWithError
                v-model="localForm[`birthStateChild${childIndex}`]"
                :id="`birthStateChild${childIndex}`"
                :name="`Child ${childIndex} Birth State`"
                label="State or territory"
                maxlength="70"
                size="15"
                @input="onInputChange"
              />
            </li>
            <li>
              <InputWithError
                v-model="localForm[`dateOfBirthChild${childIndex}`]"
                :id="`dateOfBirthChild${childIndex}`"
                :name="`Child ${childIndex} Date of birth`"
                label="Date of birth"
                size="10"
                type="date"
                :max="today"
                @input="onInputChange"
              />
            </li>
          </ol>
        </fieldset>
        <fieldset>
          <legend>
            <span class="label">Your child's registered name </span>
          </legend>
          <ol class="questions">
            <li>
              <InputWithError
                v-model="localForm[`child${childIndex}GivenName`]"
                :id="`child${childIndex}GivenName`"
                :name="`Child ${childIndex} Given Name`"
                label="First name"
                size="35"
                maxlength="60"
                @input="onInputChange"
              />
            </li>
            <li>
              <label :for="`child${childIndex}MiddleNames`">
                <span class="label">Middle name(s)</span>
              </label>
              <input
                :id="`child${childIndex}MiddleNames`"
                autocomplete="additional-name"
                v-model="localForm[`child${childIndex}MiddleNames`]"
                :name="`Child ${childIndex} Middle Name(s)`"
                type="text"
                class="stretchWidth"
                maxlength="255"
                @input="onInputChange"
              />
            </li>
            <li>
              <InputWithError
                v-model="localForm[`child${childIndex}FamilyName`]"
                :id="`child${childIndex}FamilyName`"
                :name="`Child ${childIndex} Family Name`"
                label="Family name"
                size="30"
                maxlength="60"
                hint="If your child doesn't have a family name and only uses the
                name above, enter n/a."
                @input="onInputChange"
              />
            </li>
            <li>
               <ValidationProvider :rules="`required:#label-child${childIndex}Sex`">
                 <!-- use a hidden input to trick vue validate to work with select -->
                 <input 
                   type="text" 
                   class="form-control disabled" 
                   :name="`Child ${childIndex} Sex`" 
                   v-model="localForm[`child${childIndex}Sex`]" 
                   style="display:none;"
                 />
               </ValidationProvider>
               <label :for="`child${childIndex}Sex`" :id="`label-child${childIndex}Sex`">
                 <span class="label">Sex</span>
                 <abbr class="required" title="(required)">*</abbr>
                 <small class="hint">This is the sex shown on your child's birth certificate.</small>
               </label>
               <select
                 :id="`child${childIndex}Sex`"
                 :name="`Child ${childIndex} Sex`"
                 v-model="uiSex"
                 @change="syncSelects(); onInputChange();"
               >
                 <option selected disabled>- please select -</option>
                 <option value="male">Male</option>
                 <option value="female">Female</option>
                 <option value="anotherterm">Another Term</option>
               </select>
             </li>
             <li v-if="localForm[`child${childIndex}Sex`] === 'anotherterm'">
               <InputWithError 
                 v-model="localForm[`child${childIndex}SexOther`]"
                 :id="`child${childIndex}SexOther`"
                 :name="`Child ${childIndex} Sex Descriptor`"
                 label="What descriptor is shown on your child's birth certificate?"
                 maxlength="60"
                 size="30"
                 @input="onInputChange"
               />
             </li>
            <li v-if="childIndex < 3">
              <input
                v-model="
                  localForm[`addAnotherChildToMyApplication${childIndex}`]
                "
                type="checkbox"
                value="false"
                :id="`addAnotherChildToMyApplication${childIndex}`"
                @change="onInputChange"
              /><label :for="`addAnotherChildToMyApplication${childIndex}`"
                >Add another child to my application form</label
              >
            </li>
            <div class="status info" v-if="(childIndex === 3)">
              If you have more than 3 children who need replacement certificates
              complete and submit another application.
            </div>
          </ol>
        </fieldset>
      </li>
    </ol>
  </li>
</template>

<script>
import InputWithError from '../../../InputWithError.vue';

export default {
  components: {
    InputWithError,
  },
  computed: {
    childIndex: {
      get() {
        return this.index;
      },
      set(val) {
        this.index = val;
      }
    }
  },
  props: {
    form: Object,
    index: Number,
  },
  data() {
    return {
      localForm: this.form,
      today: new Date().toISOString().split("T")[0],
      uiSex: "",
    };
  },
  methods: {
    onInputChange() {
      this.$emit("change", this.localForm);
    },
    syncSelects() {
      this.localForm[`child${this.childIndex}Sex`] = this.uiSex;
    }
  },
  watch: {
    localForm() {
      this.$emit("change", this.localForm);
    }
  }
};
</script>
